import { AttendanceProcedureReqEval } from "@/@types/esus/AttendanceProcedureReqEval";
import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";
import { IndicatorEsfStatusEnum } from "@/utils/enums/IndicatorEsfStatusEnum";

export type DetailedCitizensCervicalCancerProceduresIndicatorC7Params =
	Partial<PaginationFilter> & {
		uf: string;
		ibgeCode: string;
		quarter: string;
		year: number;
		month: number;
		search: string;
		ine?: string;
		isEvaluated?: boolean;
		export?: boolean;
	};

export class DetailedCitizenCervicalCancerProceduresIndicatorC7Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId: number = 0;
	healthTeamId: number = 0;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	attendanceProcedureReqEvals?: AttendanceProcedureReqEval[];
	lastCervicalCancerProcedureStatus: IndicatorEsfStatusEnum = IndicatorEsfStatusEnum.Lost;
}

export async function getDetailedCitizensCervicalCancerProceduresIndicatorC7({
	uf,
	ibgeCode,
	...params
}: DetailedCitizensCervicalCancerProceduresIndicatorC7Params) {
	const response = await esusApi.get<
		Paginated<DetailedCitizenCervicalCancerProceduresIndicatorC7Data>
	>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c7/detailed-citizens-cervical-cancer-procedures`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenCervicalCancerProceduresIndicatorC7Data>();
}
